import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {interval, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {DateTime, Duration} from 'luxon';

@Component({
  selector: 'fuse-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FuseCountdownComponent implements OnInit, OnDestroy {

  /**
   * Constructor
   */
  constructor() {
    // Set the defaults
    this.countdown = {
      days: '',
      hours: '',
      minutes: '',
      seconds: ''
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }
  // Event date
  // tslint:disable-next-line:no-input-rename
  @Input('eventDate')
  eventDate;

  countdown: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Converts given seconds to a remaining time
   *
   * @param seconds
   * @private
   */
  private; static _secondsToRemaining(seconds): any {
    const timeLeft = Duration.fromMillis(seconds / 60);

    return {
      days: timeLeft.days.toFixed(0),
      hours: timeLeft.hours,
      minutes: timeLeft.minutes,
      seconds: timeLeft.seconds
    };
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    const currDate = DateTime.now();
    const eventDate = DateTime.fromJSDate(this.eventDate);

    // Get the difference in between the current date and event date in seconds
    let diff = eventDate.diff(currDate, 'seconds').seconds;

    // Calculate the remaining time for the first time so there will be no
    // delay on the countdown
    this.countdown = FuseCountdownComponent._secondsToRemaining(diff);

    // Create a subscribable interval
    const countDown = interval(1000)
      .pipe(
        map(() => {
          return diff = diff - 1;
        }),
        map(value => {
          return FuseCountdownComponent._secondsToRemaining(value);
        })
      );

    // Subscribe to the countdown interval
    countDown
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(value => {
        this.countdown = value;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }

}
